export class PermissionConstants {
    // Global
    public static Development: string = "rs-development";
    // Asset
    public static LGT_Archive_Asset: string = "lgt-archive-asset";
    public static LGT_Delete_Asset: string = "lgt-delete-asset";
    public static LGT_Verify_Asset: string = "lgt-verify-asset";
    public static LGT_Export_Asset: string = "lgt-export-asset";
    public static LGT_Import_Asset: string = "lgt-import-asset";
    public static LGT_Command_Asset: string = "lgt-command-asset";
    public static LGT_Create_Asset: string = "lgt-create-asset";
    public static LGT_Show_History_Asset: string = "lgt-show-history-asset";
    public static LGT_Approve_Asset:  string = "lgt-approve-asset";

    public static LGT_Manage_Tag: string = "lgt-manage-tag";
    public static LGT_Show_History_Menu: string = "lgt-show-history-menu";
    public static LGT_Show_Archive: string = "lgt-archive-asset";
    public static LGT_Show_Guideline: string = "lgt-show-guideline";
    public static LGT_Show_Masterline: string = "lgt-show-masterline";
    public static LGT_Show_All_Masterline: string = "lgt-show-all-masterline";
    public static LGT_Show_Processing: string = "lgt-show-processing";
    public static LGT_Show_Lightable: string = "lgt-show-lightable";
    public static GEC_Show_Company: string = "gec-show-company-list";

    public static LGT_Show_Publicity: string = "lgt-access-publicity";
    public static LGT_Create_Selection: string = "lgt-create-selection";
    public static LGT_Create_Video: string = "lgt-add-video";
    public static LGT_Show_Video: string = "lgt-access-video";
    public static LGT_Archive_Video: string = "lgt-archive-video";


}
